/*
 * Initialise l'ouverture automatique des modals si le paramètre show= est passé dans l'url
 *
 * @version 0.0.1 - 30/03/2026 by LM -
 */
export const initModalAutoOpen = () => {
    const url = new URL(window.location.href)
    if(url.searchParams.has('show')) {
        const openModalButton : HTMLElement = document.querySelector(`[data-modal-target="${url.searchParams.get('show')}"]`)
        if(openModalButton) {
            openModalButton.click()
        }
    }
}
